import styled from 'styled-components'

import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'

const MainVideoSection = () => {
  return (
    <Section>
      <YoutubeViedo
        src="https://www.youtube.com/embed/_kavbpAHE9w?controls=0"
        title="Mfinder YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></YoutubeViedo>
    </Section>
  )
}

export default MainVideoSection

const Section = styled.section`
  padding: 150px 0 189px;

  ${mediaTablet} {
    padding: 72px 0;
  }

  ${mediaMobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
`
const YoutubeViedo = styled.iframe`
  width: 100%;
  height: 675px;

  ${mediaTablet} {
    height: 304px;
  }

  ${mediaMobile} {
    height: 203px;
  }
`
